// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__PElRv","buttons":"Footer_buttons__2udl7"};